import React from "react";
import {withLazyComponent} from "./lazyComponent";

export const protectedRoute = [
    {
        path: "/dashboard",
        element: withLazyComponent(
            React.lazy(() => import("../pages/dashboard/view"))
        ),
    },
    {
        path: "/profile",
        name: "Profile",
        element: withLazyComponent(
            React.lazy(() => import("../pages/profile/view"))
        ),
    },
    {
        path: "/referral",
        name: "Referral",
        id: "referral",
        element: withLazyComponent(
            React.lazy(() => import("../pages/referral/view"))
        ),
    },
    {
        path: "/self-trade",
        name: "Self-Trade",
        element: withLazyComponent(
            React.lazy(() => import("../pages/selfTrade/view"))
        ),
    },
    {
        path: "/wallet-operations",
        name: "Wallet Operations",
        element: withLazyComponent(
            React.lazy(() => import("../pages/walletOperations/view"))
        ),
    },
    {
        path: "/wallet-deposit",
        name: "Deposit",
        id: "ewallet-deposit",
        element: withLazyComponent(
            React.lazy(() => import("../pages/walletDeposit/view"))
        ),
    },
    {
        path: "/wallet-withdrawal",
        name: "Withdrawal",
        id: "ewallet-withdrawal",
        element: withLazyComponent(
            React.lazy(() => import("../pages/walletWithdrawal/view"))
        ),
    },
    {
        path: "/wallet-exchange",
        name: "Wallet Exchange",
        id: "ewallet-exchange",
        element: withLazyComponent(
            React.lazy(() => import("../pages/walletExchange/view"))
        ),
    },
    // {
    //     path: "/account-verification",
    //     name: "Verification",
    //     element: withLazyComponent(
    //         React.lazy(() => import("../pages/accountVerification/view"))
    //     ),
    // },
    {
        path: "/account-verification",
        name: "Verification V2",
        element: withLazyComponent(
            React.lazy(() => import("../pages/accountVerificationV2/view"))
        ),
    },
    {
        path: "/market-news",
        moduleName: "Market News",
        id: "market-news",
        element: withLazyComponent(
            React.lazy(() => import("../pages/marketNews/view"))
        ),
    },
    {
        path: "/trade-ideas",
        moduleName: "Trade Ideas",
        id: "trade-ideas",
        element: withLazyComponent(
            React.lazy(() => import("../pages/tradeIdeas/view"))
        ),
    },
    {
        path: "/economic-calendar",
        moduleName: "Economic Calendar",
        id: "economic-calendar",
        element: withLazyComponent(
            React.lazy(() => import("../pages/economicCalendar/view"))
        ),
    },
    {
        path: "/ai-technical-screener",
        moduleName: "A.I Technical Screener",
        id: "ai-technical-screener",
        element: withLazyComponent(
            React.lazy(() => import("../pages/aiTechnicalScreener/view"))
        ),
    },
    {
        path: "/platform-download",
        element: withLazyComponent(
            React.lazy(() => import("../pages/platformDownload/view"))
        ),
    },
    {
        path: "/smart-score",
        moduleName: "Smart Score",
        id: "smart-score",
        element: withLazyComponent(
            React.lazy(() => import("../pages/smartScore/view"))
        ),
    },
    {
        path: "/live-broadcast",
        moduleName: "LIVE Broadcast",
        id: "live-broadcast",
        element: withLazyComponent(
            React.lazy(() => import("../pages/liveBroadcast/view"))
        ),
    },
    {
        path: "/market-buzz",
        moduleName: "Market Buzz",
        id: "market-buzz",
        element: withLazyComponent(
            React.lazy(() => import("../pages/marketBuzz/view"))
        ),
    },
    {
        path: "/delete-account",
        moduleName: "Smart Score",
        element: withLazyComponent(
            React.lazy(() => import("../pages/deleteAccount/view"))
        ),
    },
    {
        path: "/coming-soon",
        element: withLazyComponent(
            React.lazy(() => import("../pages/_error/pageComingSoon"))
        ),
    },
    {
        path: "/mam-pamm",
        moduleName: "MAM/PAMM",
        element: withLazyComponent(
            React.lazy(() => import("../pages/mamPamm/_list/view"))
        ),
    },
    {
        path: "/mam-pamm/money-manager-acc",
        moduleName: "MAM/PAMM",
        element: withLazyComponent(
            React.lazy(() => import("../pages/mamPamm/moneyManagerAccount/view"))
        ),
    },
    {
        path: "/promo-materials",
        moduleName: "Promo Materials",
        element: withLazyComponent(
            React.lazy(() => import("../pages/promoMaterials/view"))
        ),
    },
    {
        path: "/client-trades",
        moduleName: "Client Trades",
        id: "reports",
        element: withLazyComponent(
            React.lazy(() => import("../pages/reports/clientTrades/view"))
        ),
    },
    {
        path: "/client-listing",
        moduleName: "Client Listing",
        id: "reports",
        element: withLazyComponent(
            React.lazy(() => import("../pages/reports/clientListing/view"))
        ),
    },
    {
        path: "/commissions",
        moduleName: "Commissions",
        id: "reports",
        element: withLazyComponent(
            React.lazy(() => import("../pages/reports/commissions/view"))
        ),
    },
    {
        path: "/client-deposits-withdrawals",
        moduleName: "Client Deposits/Withdrawals",
        id: "reports",
        element: withLazyComponent(
            React.lazy(() => import("../pages/reports/clientDepositWithdrawal/view"))
        ),
    },
    {
        path: "/client-trading-accounts",
        moduleName: "Client Trading Accounts",
        id: "reports",
        element: withLazyComponent(
            React.lazy(() => import("../pages/reports/clientTradingAccounts/view"))
        ),
    },
    {
        path: "/volume-commission",
        moduleName: "Volume Commission",
        id: "reports",
        element: withLazyComponent(
            React.lazy(() => import("../pages/reports/volumeCommission/view"))
        ),
    },
    {
        path: "/spread-earnings-commission",
        moduleName: "Spread Earnings Commission",
        id: "reports",
        element: withLazyComponent(
            React.lazy(() => import("../pages/reports/spreadEarningsCommission/view"))
        ),
    },
    {
        path: "/profit-sharing-commission",
        moduleName: "Profit Sharing Commission",
        id: "reports",
        element: withLazyComponent(
            React.lazy(() => import("../pages/reports/profitSharingCommission/view"))
        ),
    },
    {
        path: "/ai-bot-strategy",
        moduleName: "AI Bot Strategy",
        id: "ai-bot-strategy",
        element: withLazyComponent(
            React.lazy(() => import("../pages/aiBotStrategy/view"))
        ),
    },
    {
        path: "/strategy-builder",
        moduleName: "Strategy Builder",
        // id: "strategy-builder",
        element: withLazyComponent(
            React.lazy(() => import("../pages/strategyBuilder/view"))
        ),
    },
];
